var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-loading"},[_c('bim-text',{staticClass:"text-center",attrs:{"type":"h5","bold":""}},[_vm._v("Пожалуйста подождите...")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('bim-text',{staticClass:"text-center",attrs:{"type":"main"}},[_vm._v("Подбираем аналоги")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading__wrapper mt-11 mb-9"},[_c('div',{staticClass:"loading__line"})])
}]

export { render, staticRenderFns }